<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>Add Participant</cll-dialog-title>
    </cll-dialog-header>
    <div class="dialog-detail">
        <div class="dialog-container-header">
            <cll-icon type="outlined" [size]="24">send</cll-icon>
            <span class="dialog-container-header-text">Send to</span>
        </div>
        <div>
            <cll-form-field label="Participants" class="small-input">
                <cll-select [options]="searchableUsersDataSource" 
                [formControl]="participantFormGroup.controls.participant_id" />
            </cll-form-field>
        </div>
    </div>
    <span class="dialog-divider"></span>
    <cll-dialog-footer>
        <button cll-button
                colour="variant"
                cllDialogClose>
            Cancel
        </button>
        <button cll-filled-button
                colour="secondary" (click)="addParticipant()">
            <cll-icon type="outlined">add</cll-icon>
            Add
        </button>
    </cll-dialog-footer>
</cll-dialog-layout>

